<template>
  <nuxt-link v-if="link.type === 'internal'" :to="to"><slot /></nuxt-link>
  <a v-else :href="link.url" :target="link.target"><slot /></a>
</template>

<script>
export default {
  name: 'SanityLink',
  props: {
    link: { type: Object, required: true },
  },
  computed: {
    to() {
      return this.link.type === 'internal'
        ? this.$contextSanityPath(this.link.internalLink)
        : this.link.url
    },
  },
}
</script>
